module.exports = __webpack_public_path__ + "img/bean-bag.c92d6ee1.svg";